module.exports = __webpack_public_path__ + "static/media/calendar_icon.37ec4de6.svg";